import { defineStore } from 'pinia'

import state from './state'
import getters from './getters'
import actions from './actions'

const useFilesStore = defineStore('files', {
  state,
  getters,
  actions
})

export default useFilesStore
